interface DiscussionMessageData {
  id?: number;
  discussionId?: number;
  message?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}

export class DiscussionMessage {
  public static getNonTranslatableFields(): string[] { return ['id', 'discussionId', 'message', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'discussionId', 'message', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  discussionId?: number;
  message?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;


  public static fromAPI(data: DiscussionMessageData): DiscussionMessage {
    return new DiscussionMessage(data);
  }

  public static fromAPIList(data: DiscussionMessageData[]): DiscussionMessage[] {
    return data.map(item => DiscussionMessage.fromAPI(item));
  }

  constructor({ id, discussionId, message, createDate, createrId, updateDate, updaterId, deleteDate, deleterId }: DiscussionMessageData = {}) {
    this.id = id;
    this.discussionId = discussionId;
    this.message = message;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): DiscussionMessageData {
    return  {
      id: this.id,
      discussionId: this.discussionId,
      message: this.message,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
